import { request } from '@/utils/api-request'


export function getDocentHistoryList(params) {
  const url = "/admin/docent/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getDocentHistoryDetail(params) {
  const url = "/admin/docent/detail";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function updateDocentHistory(params) {
  const url = "/admin/docent/update";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getGeoDocentHistoryList(params) {
  const url = "/admin/geo/docent/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getGeoDocentHistoryDetail(params) {
  const url = "/admin/geo/docent/detail";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function updateGeoDocentHistory(params) {
  const url = "/admin/geo/docent/update";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getBeusDocentHistoryList(params) {
  const url = "/admin/beus/docent/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getBeusDocentHistoryDetail(params) {
  const url = "/admin/beus/docent/detail";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function updateBeusDocentHistory(params) {
  const url = "/admin/beus/docent/update";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}
